import { SearchContext } from 'contexts/SearchProvider';
import React from 'react';

export function useSearch() {
  return React.useContext(SearchContext);
}
